export const Section = (props) => {
  return <section className="section">{props.children}</section>;
};
